import { render, staticRenderFns } from "./twas.vue?vue&type=template&id=3df8ef8b&scoped=true&"
import script from "./twas.vue?vue&type=script&lang=js&"
export * from "./twas.vue?vue&type=script&lang=js&"
import style0 from "./twas.vue?vue&type=style&index=0&id=3df8ef8b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8ef8b",
  null
  
)

export default component.exports